import { motion } from 'framer-motion';
import styled from 'styled-components';

import { PeopleSearchBarMinimalStateWrapper } from '../PeopleSearchBar/styled';

export const PeopleSearchTabletWrapper = styled(motion.div).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
})`
  width: 100%;
  height: 100%;

  position: fixed;
  top: calc(var(--navbar-height) + 51px);
  left: 0;

  display: flex;
  justify-content: center;

  z-index: 1001;
`;

export const PeopleSearchTabletContainer = styled.div`
  width: 650px;
  max-width: calc(100% - 32px);
  height: fit-content;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #ffffff;
  border-radius: 8px;

  ${PeopleSearchBarMinimalStateWrapper} {
    min-height: 67px;
  }
`;
